import React, { useState, useEffect } from 'react';
import { Button, Form, Col, Row, InputGroup, Modal, Card } from 'react-bootstrap';
import { Header, Divider, Segment, Image, Dimmer, Loader } from 'semantic-ui-react'
import Amplify, { Auth, API, Storage } from 'aws-amplify';
import { message, Typography } from 'antd';
import { Jsme } from 'jsme-react';
import SubstrateTable from './SubstrateTable';

function simulateNetworkRequest() {
	return new Promise((resolve) => setTimeout(resolve, 100000));
}

export default function SubstrateSimi() {

	Date.prototype.format = function (fmt) {
		var o = {
			"M+": this.getMonth() + 1,                   //月份
			"d+": this.getDate(),                        //日
			"h+": this.getHours(),                       //小时
			"m+": this.getMinutes(),                     //分
			"s+": this.getSeconds(),                     //秒
			"q+": Math.floor((this.getMonth() + 3) / 3), //季度
			"S": this.getMilliseconds()                  //毫秒
		};

		//  获取年份 
		// ①
		if (/(y+)/i.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
		}

		for (var k in o) {
			// ②
			if (new RegExp("(" + k + ")", "i").test(fmt)) {
				fmt = fmt.replace(
					RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
			}
		}
		return fmt;
	}

	const [type, setType] = useState("SDF");
	const [smiles, setSmiles] = useState("");
	const [inchi, setInchi] = useState("");
	const [path1, setPath1] = useState("");
	const [disable, setDisable] = useState(true);
	const [isLoading, setIsLoading] = useState(false);

	const [show, setShow] = useState(false);

	const [URL, setURL] = useState();
	const [display_result, setDisplay_result] = useState(false);
	const [isLoaded, setIsLoaded] = useState(false);

	const Bucket = "s3://p450-result-prod/public/";
	var Path1;


	useEffect(() => {
		if (isLoading) {
			simulateNetworkRequest().then(() => {
				setIsLoading(false);
			});
		}
	}, [isLoading]);

	const handleClose = () => {
		setShow(false);
	};

	function logSmiles(e) {
		setSmiles(e);
	}

	function handleFile1(e) {

		let ts = new Date().getTime();

		const file = e.target.files[0];
		let filename = ts + "/" + file.name;

		Storage.put(filename, file, {
			progressCallback(progress) {
				var percentage = (progress.loaded / progress.total * 100).toFixed(1);
				message.loading({ content: "SDF Upload:   " + percentage + '%', key: "sdf", style: { marginTop: '40vh', } }, 0);
			}
		})
			.then(result => {
				// console.log(result);
				Path1 = Bucket + filename;
				console.log(Path1);
				setPath1(Path1);
				setTimeout(() => {
					message.success({ content: 'SDF upload completed', style: { marginTop: '40vh' } });
					// setDisable_submit(false);
				}, 1000);
				// setDisable(false);

			})
			.catch(err => {
				console.log(err);
			});

	}

	useEffect(() => {
		if (type === "SDF") {
			if (path1 !== "") {
				setDisable(false);
			} else {
				setDisable(true);
			}
		} else if (type === "SMILES") {
			if (smiles !== "") {
				setDisable(false);
			} else {
				setDisable(true);
			}
		} else {
			if (inchi !== "") {
				setDisable(false);
			} else {
				setDisable(true);
			}
		}

	}, [path1, type, smiles, inchi])


	function handleSubmit() {
		setIsLoading(true);
		setIsLoaded(false);
		setDisplay_result(true);
		let current = type === "SDF" ? path1 : (type === "SMILES" ? smiles : inchi)
		postRequest(current);

	}

	async function postRequest(props) {
		// Amplify.Logger.LOG_LEVEL = "DEBUG";
		// const session = await Auth.currentCredentials();
		// console.log(session)
		const apiRequest = {
			body: {
				"database": "P450",
				"value": props
			},
			headers: {
				"Content-Type": "application/json",
			},
		};

		return await API
			.post("Substrate", "/api/substrateCompute", apiRequest)
			.then(
				(data) => {
					console.log(data);
					setIsLoading(false);
					if (data.code === 0) {
						setURL(data.data.url);
						setIsLoaded(true);
					} else if (data.code === 0) {
						setDisplay_result(false);
						message.error({ content: 'ERROR: ' + data.msg, style: { marginTop: '40vh' } });
					} else {
						setDisplay_result(false);
						message.error({ content: 'ERROR: ' + data.errorMessage, style: { marginTop: '40vh' } });
					}
				},
				(error) => {
					console.log(error);
					setIsLoading(false);
				}
			);
	};

	return (
		<div style={{
			background: "#FFFFFF"

		}}>

			<Row>
				<Col>
				</Col>
				<Col md={10}>

					<div style={{

						height: "50px"
					}}>
					</div>
					<div>


						<Card>
							<Card.Header>
								<Header style={{ color: "#6495ED", textAlign: "center" }} >Searching Substrate Molecules</Header>
							</Card.Header>
							<Card.Body>
								<div style={{ margin: "25px 75px 25px 75px" }}>
									<Typography.Paragraph italic style={{ textAlign: "justify" }}><blockquote>Based on the substrate molecule submitted by the user, search for functionally characterized P450 enzymes with similar substrate molecules and output only the top 10 results.</blockquote></Typography.Paragraph>
								</div>
								<Form>
									<Form.Group as={Row} >
										<Form.Label column sm="3" className="top3">
											Input Type
										</Form.Label>
										<Col sm="8">
											<Form.Control as="select" value={type} onChange={(e) => setType(e.target.value)} >
												<option value="SDF">SDF</option>
												<option value="SMILES">SMILES</option>
												<option value="InChI">InChI</option>
											</Form.Control>

										</Col>

									</Form.Group>

									{/* <Divider /> */}

									{
										type === "SDF"
											?
											<Form.Group as={Row} >
												<Form.Label column sm="3" className="top3">
													Upload SDF file
												</Form.Label>
												<Col sm="8">
													<Form.File id="exampleFormControlFile1" onChange={handleFile1} accept=".sdf" />

												</Col>

											</Form.Group>
											:
											null
									}

									{
										type === "SMILES"
											?
											<Form.Group as={Row} >
												<Form.Label column sm="3" className="top3">
													SMILES
												</Form.Label>
												<Col sm="8">

													<InputGroup>
														<Form.Control type="text" placeholder="e.g.: C1=CC=C(C=C1)C=O" onChange={(e) => setSmiles(e.target.value)} />
														<InputGroup.Append>
															<Button variant="outline-secondary" onClick={() => { console.log("click"); setShow(true) }}>Draw</Button>
														</InputGroup.Append>
													</InputGroup>
												</Col>

											</Form.Group>
											:
											null
									}

									{
										type === "InChI"
											?
											<Form.Group as={Row} >
												<Form.Label column sm="3" className="top3">
													InChI
												</Form.Label>
												<Col sm="8">
													<Form.Control type="text" placeholder="e.g.: InChI=1S/C7H6O/c8-6-7-4-2-1-3-5-7/h1-6H" onChange={(e) => setInchi(e.target.value)} />

												</Col>

											</Form.Group>
											:
											null
									}

									{/* <Divider /> */}

									<div style={{ textAlign: "center" }}>
										<Button
											variant="outline-primary"
											disabled={disable}
											onClick={!isLoading ? handleSubmit : null}

										>
											{isLoading ? 'PROCESSING' : 'SUBMIT'}
										</Button>
									</div>
									<div style={{ height: "25px" }} />

								</Form>
							</Card.Body>
						</Card>

						{
							display_result
								?
								<Card>
									<Card.Body>
										{
											isLoaded
												?
												<SubstrateTable url={URL} />
												:
												<Segment>
													<Dimmer active inverted>
														<Loader size='medium'>Loading</Loader>
													</Dimmer>

													<Image src='../paragraph.png' />
												</Segment>
										}
									</Card.Body>
								</Card>
								:
								null
						}


					</div>

					<Modal
						show={show}
						onHide={handleClose}
						style={{ minWidth: "670px" }}
					// dialogClassName="modal-670px"
					// aria-labelledby="example-custom-modal-styling-title"
					>
						<Modal.Header closeButton>
							<Modal.Title>SMILES Drawer</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<Jsme height="500px" width="670px" options="newlook,star" onChange={logSmiles} />
						</Modal.Body>
					</Modal>

					<div style={{

						height: "50px"
					}}>
					</div>
				</Col>
				<Col>
				</Col>
			</Row>
		</div>

	);
};